import Logo from '../../assets/images/logo.svg';
import { HiOutlineEnvelope } from "react-icons/hi2";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import WebService from "../../Services/WebService";
import { useForm } from "react-hook-form";
import "./forgotpassword.scss";
import { toast } from "react-toastify";
import { Button, Spinner } from 'react-bootstrap';
const ForgotPassword = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const [error, setError] = useState<any>(false);
    const [loading, setLoading] = useState<any>(false);
    const history = useNavigate();
    const onSave = (data: any) => {
        setLoading(true);
        WebService.postAPI({
            action: `/forgot-password`,
            body: {
                email: data.email,
            },
        })
            .then((res: any) => {
                if (res) {
                    setLoading(false);
                    toast.success(res.message);
                    history("/verify-otp", { state: { email: data.email } });
                }

            })
            .catch((e) => {
                setError(true);
                toast.error(e?.response?.data?.message);
                setLoading(false);
            });
    };
    return (
        <>
            <div className="login-page">
                <div className="row justify-content-center min-vh-100 align-items-center mx-0">
                    <div className="col-lg-5 d-flex align-items-center justify-content-center">
                        <div className="w-75 login-card rounded-4">
                            <div className="px-lg-5 px-3 py-5">
                                <div className="mb-3 text-center">
                                    <img src={Logo} width="100" height={50} alt="Logo" />
                                </div>
                                <form onSubmit={handleSubmit(onSave)}>
                                    <div>
                                        <h1 className="text-black mb-4 font-bold text-center h2">Welcome to Brizz</h1>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                                    <HiOutlineEnvelope size={16} />
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control border-start-0 ps-0"
                                                    autoComplete="off"
                                                    placeholder="Enter email"
                                                    {...register("email", {
                                                        required: "Email is required",
                                                        pattern: {
                                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                            message: "Enter a valid email address",
                                                        },
                                                    })}
                                                />

                                            </div>
                                            <div className="mt-1">
                                                {errors.email?.type === "required" && (
                                                    <small className="text-danger">Email is required</small>
                                                )}
                                                {errors.email?.type === "pattern" && (
                                                    <small className="text-danger">Please enter  valid email</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-4 text-center">
                                        <Button type="submit" className="btn btn-brand-1 w-100">
                                            {loading ? (
                                                <Spinner size="sm" className="me-2"></Spinner>
                                            ) : null}
                                            Send
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
export default ForgotPassword;